var photo = "https://shopfront-cdn.tekoapis.com/static/c486cae13baa79ad.svg";

export { photo as default };
